import { render, staticRenderFns } from "./request-boat-modal.vue?vue&type=template&id=cf06a2aa"
import script from "./request-boat-modal.vue?vue&type=script&lang=js"
export * from "./request-boat-modal.vue?vue&type=script&lang=js"
import style0 from "./request-boat-modal.vue?vue&type=style&index=0&id=cf06a2aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/var/www/tubber-new/components/global/v/button.vue').default,BaseModal: require('/var/www/tubber-new/components/global/base-modal.vue').default})
